import { UserRound } from "lucide-react";

const dateFormat = new Intl.DateTimeFormat("ro-RO", { timeZone: "Europe/Bucharest", day: "2-digit", month: "2-digit", year: "numeric" });
const timeFormat = new Intl.DateTimeFormat("ro-RO", { timeZone: "Europe/Bucharest", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });

export const AccessHistoryTable = ({ events, pending }) => (
  <table className="access-history-table" data-testid="access-history-table" aria-busy={!!pending}>
    <caption className="sr-only">Autentificări reușite, de la cea mai recentă. Orele sunt în fusul Europe/Bucharest.</caption>
    <colgroup><col className="access-history-account-col" /><col className="access-history-date-col" /><col className="access-history-time-col" /></colgroup>
    <thead><tr><th scope="col">Cont</th><th scope="col">Data</th><th scope="col">Ora</th></tr></thead>
    <tbody>
      {events.map((event) => {
        const when = new Date(event.logged_in_at);
        return (
          <tr key={event.id} data-testid={`access-event-${event.id}`}>
            <th scope="row" data-testid={`access-account-${event.id}`}><span className="access-history-account"><UserRound size={18} strokeWidth={1.5} aria-hidden="true" /><span>{event.account}</span></span></th>
            <td data-testid={`access-date-${event.id}`}><time dateTime={event.logged_in_at}>{dateFormat.format(when)}</time></td>
            <td data-testid={`access-time-${event.id}`}><time dateTime={event.logged_in_at}>{timeFormat.format(when)}</time></td>
          </tr>
        );
      })}
    </tbody>
  </table>
);